<template>
  <div class="component-container">
    <h3>MSPNG1 Forces: Contact and Non-Contact - Downloads and Resources</h3>
    <div class="back-button-wrapper">
      <button type="button" @click.prevent="cancelButton" class="back-button">Back to Main Dashboard</button>
    </div>
    <div class="presentations">
      <h4>Teacher Presentations</h4>
      <ul>
          <li><a href="https://firebasestorage.googleapis.com/v0/b/ccs-online-prototype.appspot.com/o/activityPresentations%2FJanuary%202026%20Updates%2FMSPNG1%20Activities%201-6-20260112T163324Z-3-001.zip?alt=media&token=7432c8bc-1e46-40b8-a1cd-73cd4ab86535" target="_blank">Teacher Presentations: Activities 1 - 6 (Updated 1/12/2026)</a></li>
          
          <li><a href="https://docs.google.com/spreadsheets/d/1RZrQWEcgAu2kxE60cdaDCwpFOj35RFvl_ZiPRYWxAXw/edit?usp=sharing" target="_blank">Teacher Guide Links Spreadsheet</a> - List of all links in the printed Teacher Guide</li>
          <li><a href="https://docs.google.com/spreadsheets/d/1qe8R8GD92WO6dtzWri9pKbKWjAYx2siuRzdE8bcT_6c/edit?gid=1062009112#gid=1062009112">Curriculum Updates Spreadsheet </a> - List with links to updates for your printed Teacher Guide</li>
        </ul>
    </div>
    <div class="presentations">
      <h4>Student Journals</h4>
      <p>Please make a master copy for your classroom and save to your Google drive for your classroom.</p>
      <ul>
        <li><a href="https://docs.google.com/presentation/d/1rzOUG41c6erVwBfUaKSYpPXgZBG0Oa44pWHVKmQSxS8/copy" target="_blank">MPSNG1 Forces: Contact and Non-Contact Student Journal</a></li>
        <li><a href="https://drive.google.com/file/d/1aN4ADEXDwiQg3TTwJ7iD8oB6vqybUDZQ/view" target="_blank">MPSNG1 Forces: Contact and Non-Contact Student Journal Answer Key</a></li>
      </ul>

    </div>
    <div class="presentations">
      <h4>Individual Resources</h4>
      <p>The resources below are also linked in the Teacher Led Presentations. We've provided them here for anyone wishing to have access to these individual resources outside of the presentations. Please make master copies and save in your Google drive for your classroom.</p>
        <h4 style="margin-left: 10px;">Charts, Handouts, Card Sets, etc.</h4>
        <ul>
          <li><a href="https://docs.google.com/presentation/d/1sfQGATd8Gwz1okGZEiamQkekldDByHs-gRxX6xqMlnE/copy" target="_blank">Lesson 1A - Anchor Charts</a></li>
          <li><a href="https://docs.google.com/presentation/d/1AmauEhAALsxXoFzN9COChSFmb8nrqPAiDLaPx4M58hI/copy" target="_blank">Lesson 1A - What We Think Chart</a></li>
          <li><a href="https://docs.google.com/presentation/d/1-Kl1dW2btlUGC93X5pP2n0U6d50WMVsXRJCQVClFz3Q/copy" target="_blank">Lesson 1A - Initial Model of Collision</a></li>
          <li><a href="https://docs.google.com/presentation/d/16W9i5JZYW_s8UN7lcnuzIKz08Rs0IPaBovq_zdjtLQM/copy" target="_blank">Lesson 1A - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1M5qmcwtEnVXxDWF4Xmcx0ED5l6jOSRPNE1cybpJP2q8/copy" target="_blank">Lesson 1B - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1AjDDfMkZB_rwmL6xY44PpM2nrNvCG4DSFCe33i019iM/copy" target="_blank">Lesson 1C - Key Terms</a></li>
          <li><a href="https://docs.google.com/presentation/d/19MAyxrsp9lLcdwo3CDOmYHOqL8-kk3630E2tMt-EOlg/copy" target="_blank">Lesson 1C - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Oj_fSq_VyUyTToXv0Sg8gzuvNHx9LDsYlGy1j7IcNiQ/copy" target="_blank">Lesson 2C - Model of Energy and Motion</a></li>
          <li><a href="https://docs.google.com/presentation/d/1a4obafg4JAJA4oYxNgzy-qp8-76N-RcfCOcWMZQRWhA/copy" target="_blank">Lesson 3A - Bubble Soccer Solution Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1PKE_0_qlfqvFEbLpNh674ZxaxX4NGF-oNkIG3U_w_fk/copy" target="_blank">Lesson 3B - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/18-UhMCN1UQ2oxRuJnv8WQUlvonLCeDKayfiVvML3Ld8/copy" target="_blank">Lesson 3C - Group Rafting Model</a></li>
          <li><a href="https://docs.google.com/presentation/d/11QtGRY_OZINJC80QZA2a3wXzSFHr_qJsDEjibruG1Ng/copy" target="_blank">Lesson 4A - Rock Fall Model</a></li>
          <li><a href="https://docs.google.com/presentation/d/1dA23rPyYsYmmS5gl1jXRSP05krMTM62uDAsBy5u8Sxo/copy" target="_blank">Lesson 4A - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1jWZGpjri-s7qH4wmM487fCKjoi6uPKfgPZUy18xHDI8/copy" target="_blank">Lesson 4B - Gravity as a Non-contact Force Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1Z56WYG3_8KuVjchtykYxrCn9iTjZiG3IkJrOR5Hkobg/copy" target="_blank">Lesson 4C - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/19ZXGwMrb1xtBqjpFDakZqYexqImhZSr8pxltCaV7bTo/copy" target="_blank">Lesson 5A - Floating Pen Model</a></li>
          <li><a href="https://docs.google.com/presentation/d/1nnAEl7GtUnNRe8i9k2Rj2l8rZ0n0aLrCWvG3fqF8dMg/copy" target="_blank">Lesson 5C - Magnetism Investigation Presentation Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1tU5gJQ9qLAxje5iSDDQlj5-oDgk8UN3mxFOlX8g9FXA/copy" target="_blank">Lesson 6A - Balloon Interaction Model</a></li>
          <li><a href="https://docs.google.com/presentation/d/1yHt2Q5BTJMl92wmM0wBHZn95LB4Rz1g6cfvpycI2980/copy" target="_blank">Lesson 6A - Word Sort Cards</a></li>
          <li><a href="https://docs.google.com/presentation/d/1mqWP8vgtf_C1oJcHo_rp5Atpl1dwHQe6y77EltZKje0/copy" target="_blank">Lesson 6B - Electromagnetic Model</a></li>
          <li><a href="https://docs.google.com/presentation/d/1h5zek4zJoXp8ikStSibR6F6pTmNXEeZSNFV7N1rc6Vg/copy" target="_blank">Lesson 6C - Ball Retrieving Device Product Descriptor</a></li>
          <li><a href="https://docs.google.com/presentation/d/1EEqEor01ykY38mdOHJ3Ei2yGsl2vB30CTqn1QkxDvYk/copy" target="_blank">Lesson 6C - Word Sort Cards</a></li>
          <!-- <li><a href="" target="_blank"></a></li> -->
        </ul>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
  data() {
    return {}
  },
  computed: {
    ...mapState([ 'dashboardView', 'userProfile' ])
  },
  methods: {
    cancelButton() {
      this.$store.commit('SET_DASHBOARD_VIEW', 'units')
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  }
  }
  </script>

  <style lang="css" scoped>
  .presentations {
  border: 1px solid grey;
  text-align: left;
  padding: 20px;
  margin: 0 20px 20px 20px;
  }
  ul {
  list-style: none;
  }
  .presentations a {
  margin-left: 40px;
  }
  li {
  margin-left: -40px;
  }
  .back-button-wrapper {
  width: 100%;
  text-align: left;
  margin-bottom: 0;
  }
  .back-button {
  background: white;
  border: none;
  font-weight: 600;
  color: #7b8a1d;
  margin-left: 20px;
  }
  </style>
